// api/Contractors.js
import apiClient from "./client";

export function getContractors() {
  return apiClient.get("/contractors").then((res) => res.data);
}


export function deleteContractor(id) {
  return apiClient.delete(`/contractors/${id}`).then((res) => res.data);
}

export function createContractor(data) {
  return apiClient.post("/contractors", data).then((res) => res.data);
}

export function updateContractor(data) {
  return apiClient.post("/contractors", data).then((res) => res.data);
}
